import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

import { OriginDetail } from '../models/classes/origin/origin-detail';
import { LanguageService } from './language.service';

@Injectable({
    providedIn: 'root'
})
export class OrganismService {

    private baseUrl = environment.apiUrl + 'organisms';

    constructor(
        private http: HttpClient,
        private languageSrv: LanguageService,
    ) { }

    getList(): Observable<OriginDetail[]> {
        return this.http.get<OriginDetail[]>(`${this.baseUrl}/${this.languageSrv.getCurrentLanguageCode()}`);
    }
}
